import { isNumeric } from './isNumeric';

export const formatDecimalData = (data, decimalPlaces = 2) => {
    if (!isNumeric(data)) return data;
    return Number(Number(data).toFixed(decimalPlaces));
};
